var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfilerSodar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28584 7.69238C4.49074 7.69238 3.84619 8.34419 3.84619 9.14824C3.84619 9.30905 3.9751 9.43941 4.13412 9.43941H4.42205L11.0444 31.8596H30.4796L36.958 9.43941H37.2459C37.405 9.43941 37.5339 9.30905 37.5339 9.14824C37.5339 8.34419 36.8893 7.69238 36.0942 7.69238H5.28584Z",
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1704 31.8594H30.9436V39.1828H11.1704V31.8594Z",
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0253 26.0507H11.0204V26.2007V39.1831V39.3331H11.1704H30.9436H31.0936V39.1831V26.2007V26.0507H31.0887C30.9213 21.0503 26.4832 17.0629 21.057 17.0629C15.6308 17.0629 11.1927 21.0503 11.0253 26.0507ZM29.9202 26.2171L29.9213 26.279V26.2802V38.1771H12.1928V26.2802L12.1938 26.2171C12.2663 21.8461 16.1471 18.2189 21.057 18.2189C25.9669 18.2189 29.8477 21.8461 29.9202 26.2171Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70459 39.1215C9.70459 38.953 9.8396 38.8164 10.0061 38.8164H14.0986H14.5294H26.8931H27.2808H32.0625C32.2529 38.8164 32.4072 38.953 32.4072 39.1215V42.173C32.4072 42.3415 32.2529 42.4781 32.0625 42.4781H26.8931C26.7027 42.4781 26.5484 42.3415 26.5484 42.173V41.0134H14.831V42.173C14.831 42.3415 14.696 42.4781 14.5294 42.4781H10.0061C9.8396 42.4781 9.70459 42.3415 9.70459 42.173V39.1215Z",
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7389 21.4468C32.6588 21.3079 32.7063 21.1303 32.8452 21.0501L33.8512 20.4694C33.99 20.3892 34.1676 20.4368 34.2478 20.5756L46.0084 40.9455C46.0886 41.0844 46.041 41.262 45.9021 41.3422L44.8962 41.923C44.7573 42.0032 44.5797 41.9556 44.4995 41.8167L32.7389 21.4468Z",
    fill: "#1E2447"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilerSodar);
export default __webpack_public_path__ + "static/media/profiler-sodar.b6f9a217.svg";
export { ForwardRef as ReactComponent };